import '../../Pdf/fonts';
import Column from '../../Pdf/components/Column';
import Header from '../../Pdf/components/Header';
import Typography from '../../Pdf/components/Typography';
import theme from '../../Pdf/components/theme';
import PaymentDetailsComponent from './PaymentDetails';
import { CapitalActionNoticeData, PaymentDetails } from '../types';
import { CurrencyCode } from 'further-types/lp/vehicle';
import PageTemplate from '../../Pdf/components/PageTemplate';
import Footer from '../Footer';
import { StyleSheet } from '@react-pdf/renderer';
import { htmlToPDF } from '../../Pdf/htmlToPDF';
import Row from '../../Pdf/components/Row';
import SummaryStat from './SummaryStat';
import Divider from '../../Pdf/components/Divider';
import { numberToCurrencyString } from '../../../utils/currency';

const styles = StyleSheet.create({
  footer: {
    paddingHorizontal: theme.spacing(theme.spacingSizes.sm),
  },
  header: {
    position: 'relative',
    top: `-${theme.spacing(theme.spacingSizes.lg)}`,
  },
  contentColumn: {
    paddingHorizontal: theme.spacing(theme.spacingSizes.sm),
  },
  noticeNarrative: {
    fontSize: '8px',
    fontWeight: 400,
  },
});

type Props = {
  totalNetCapitalCalledLcy: number;
  firmLogoUrl?: string;
  firmDomain: string;
  currencyLcy: CurrencyCode;
  paymentRequired: boolean;
  palette: {
    firmBackgroundColor: string;
    backgroundContrastColor: string;
    backgroundSubtleContrastColor: string;
  };
  paymentDetails: PaymentDetails;
  capitalActionNotice: CapitalActionNoticeData;
};

const PageOne = ({
  firmDomain,
  firmLogoUrl,
  currencyLcy,
  paymentRequired,
  palette,
  paymentDetails,
  capitalActionNotice,
  totalNetCapitalCalledLcy,
}: Props) => {
  return (
    <PageTemplate
      horizontalMargin="xs"
      verticalMargin="xl"
      wrap={true}
      footer={<Footer style={styles.footer} />}
    >
      <Header
        style={styles.header}
        palette={{
          backgroundColor: palette.firmBackgroundColor,
          contrastTextColor: palette.backgroundContrastColor,
          subtleContrastTextColor: palette.backgroundSubtleContrastColor,
        }}
        logoUrl={firmLogoUrl}
        bottomAdornment={
          <Column>
            <Typography variant="h3" color={palette.backgroundContrastColor}>
              {capitalActionNotice.vehicleName}
            </Typography>
            <Typography
              variant="h6"
              color={palette.backgroundSubtleContrastColor}
            >
              Capital notice: {capitalActionNotice.noticeDate.toReadable()}
            </Typography>
          </Column>
        }
      />
      <Column spacing="sm" style={styles.contentColumn}>
        <Row spacing="lg" fullWidth>
          <Column spacing="sm" fullWidth>
            <SummaryStat
              label="Investor"
              value={capitalActionNotice.investorName}
            />
            <Divider />
            <SummaryStat
              label="Vehicle"
              value={capitalActionNotice.vehicleName}
            />
            <Divider />
            <SummaryStat
              label="Total net call / (distribution)"
              value={numberToCurrencyString(totalNetCapitalCalledLcy, {
                currency: currencyLcy,
                negativeInBrackets: true,
              })}
            />
            <Divider />
            <SummaryStat
              label="Due date"
              value={capitalActionNotice.capitalDueDate.toReadable()}
            />
          </Column>
          <PaymentDetailsComponent
            paymentRequired={paymentRequired}
            paymentDetails={paymentDetails}
            firmDomain={firmDomain}
            dueDate={capitalActionNotice.capitalDueDate}
            currencyLcy={currencyLcy}
          />
        </Row>
        <Divider />
        <Column spacing="xs" fullWidth style={styles.noticeNarrative}>
          <Typography variant="h5">Reason for capital notice</Typography>
          {htmlToPDF({ content: capitalActionNotice.noticeNarrative })}
        </Column>
      </Column>
    </PageTemplate>
  );
};

export default PageOne;
